import { Card, Container } from "react-bootstrap";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import Audits_block from "../../components/personal/MainPage/Audits_block";
import { CreateAuditOffcanvass } from "../../components/reuse/CreateAuditOffcanvas";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const MainPage = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Аудиты"}>
            <Audits_block/>
        </TypicalPageStructure>
        </>
    )
}

export default MainPage;